import { useSelector } from 'react-redux';

import { getIsCreator } from '~store/auth/authSlice';

export const useIsDuplicateOwner = () => useSelector(getIsCreator);
